import { merge } from 'lodash'
import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

type State = {
  menuOpen: boolean
  modalOpen: boolean
  viewLogo: boolean
  lockScroll: boolean
  footerDark: boolean
  footerVisible: boolean
}

type Actions = {
  // eslint-disable-next-line no-unused-vars
  setLayoutState: (state?: Partial<State>) => void
}

const initialState: State = {
  menuOpen: false,
  viewLogo: false,
  modalOpen: false,
  lockScroll: false,
  footerDark: false,
  footerVisible: true
}

const useLayoutStore = create(
  subscribeWithSelector(
    immer<State & Actions>((set) => ({
      ...initialState,
      setLayoutState: (state) => set((prevState) => merge(prevState, state))
    }))
  )
)

export { useLayoutStore }
